define('viewmodels/configuration/RoleManagement',['plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils'],
    function (router, app, appsecurity, navigation, system, logger, utils) {
        var vm = {
            title: ko.observable("RoleManagement"),
            detached: detached,
            appsecurity: appsecurity,
            RolesList: ko.observableArray(),
            RolesListDup: ko.observableArray(),
            PageList: ko.observableArray(),
            PageListDup: ko.observableArray(),
            ShowUserPopUpTitle: ko.observable(),
            UsersList: ko.observableArray(),
            SelectedSurveyRoleMultiType: ko.observableArray(),
            ShowUsersPopUp: ShowUsersPopUp,
            ShowAddRolePopUp: ShowAddRolePopUp,
            ShowEditRolePopUp: ShowEditRolePopUp,
            ShowViewRolePopUp: ShowViewRolePopUp,
            ShowDeleteRolePopUp: ShowDeleteRolePopUp,
            PopUpActionType: ko.observable(),
            PopUpActionTitle: ko.observable(),
            PopUpActionCss: ko.observable(),
            RolePopUpData: ko.observable(),
            PopUpRowClick: PopUpRowClick,
            PageReadClick: PageReadClick,
            PageWriteClick: PageWriteClick,
            PageSelectClick: PageSelectClick,
            SaveRoleDetails: SaveRoleDetails,
            DataToBeSaved: ko.observable(),
            SurveyRoleType: ko.observable(),
            SurveyEditRoleType: ko.observable(),
            SurveyRoleTypeChanged: SurveyRoleTypeChanged,
            RadioOptions: ko.observableArray(["Yes", "No"]),
            SelectedSurveyRoleType: ko.observable(),
            SelectedSurveySuperUserCheck: ko.observable(),
            SurveySuperUserCheck: SurveySuperUserCheck,
            isSurveyUserApplicable: ko.observable(false),
            activate: function () {
            },
            attached: function () {
                $($(document.getElementsByClassName('list-group-item')).get(1)).addClass('active');
                GetAllPages();
                GetAllRoles();
            },
        };

        return vm;

        var RoleTableObj = false;

        function detached() {
            try {
                $($(document.getElementsByClassName('list-group-item')).get(1)).removeClass('active');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        //--------------------------------------------------------------------Logic to Fetch Initial Page Load Data Starts Here-----------------------------------------------------------
        function GetAllRoles() {
  
            utils.getJson({
                url: rootPath + "/api/Configuration/GetAllRoles",
                headers: appsecurity.getSecurityHeaders()
            }).done(function (jsonResult) {
                $('#loadingMainImgDiv').hide();
                $('#tblRole').show();
                if (jsonResult != null && jsonResult.length > 0) {
                    if (jsonResult[0].UserId != -1) {
                        vm.RolesList([]);
                        var MappedRoleList = $.map(jsonResult, function (result) {
                            return new RoleModel(result);
                        })
                        var dtable = $('#tblRole').DataTable()
                        var p = dtable.page.info().page
                        dtable.destroy();
                        $("#tblRole tbody tr").remove();
                        vm.RolesList(MappedRoleList);
                        vm.RolesListDup([]);
                        var MappedRoleListDup = $.map(jsonResult, function (result) {
                            return new RoleModel(result);
                        })
                        vm.RolesListDup(MappedRoleListDup);

                        dtable = $('#tblRole').DataTable({
                            "ordering": false,
                            "responsive": true,
                            "columnDefs": [
                                { "targets": [0], "visible": false, "responsive": true },
                                { "targets": [3], "orderable": false, "className": "text-center", "responsive": true }]
                        });
                        dtable.column(4).visible(!vm.appsecurity.WriteAccess());
                        dtable.column(5).visible(vm.appsecurity.WriteAccess());

                        dtable.page(p).draw(false);
                    }
                    else {
                        logger.logError(jsonResult[0].FlagDescription + ' - An error occurred while fetching Roles. Please contact the Administrator.', 'Error', system.getModuleId(vm), true);
                    }
                }
                else
                    logger.logError('An error occurred while fetching Roles. Please contact the Administrator.', 'Error', system.getModuleId(vm), true);
            })
                .fail(function (result) {
                    logger.logError(result[0].FlagDescription + ' - An error occurred while fetching Roles. Please contact the Administrator.', 'Error', system.getModuleId(vm), true);
            });
        }

        function GetAllPages() {

            utils.getJson({
                url: rootPath + "/api/Configuration/GetAllPages",
                headers: appsecurity.getSecurityHeaders()
            }).done(function (jsonResult) {
                if (jsonResult != null) {
                    vm.PageList([]);
                    var MappedPageList = $.map(jsonResult, function (result) {
                        return new ModuleModel(result);
                    })
                    vm.PageList(MappedPageList);

                    var MappedPageListDup = $.map(jsonResult, function (result) {
                        return new ModuleModel(result);
                    })
                    vm.PageListDup(MappedPageListDup);
                }
                else
                    logger.logError('An error occurred while fetching Page details.', 'Error', system.getModuleId(vm), true);
            }).fail(function (result) {
                logger.logError(result.responseJSON.Message+ ' - An error occurred while fetching Page details.', 'Error', system.getModuleId(vm), true);
            });
        }
        //--------------------------------------------------------------------Logic to Fetch Initial Page Load Data Ends Here-----------------------------------------------------------

        //---------------------------------------------------------------------Logic Related to Show Users Attached to a specific Role starts here-------------------------------------------

        function ShowUsersPopUp(data, event) {
            try {
                vm.ShowUserPopUpTitle("Users List With " + "\"" + data.RoleName() + "\" Role");
                $('#frmShowUsers').modal('show');
                ShowUsers(data);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowUsersPopUp() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function ShowUsers(data) {
            try {
                $.ajax({
                    url: "/api/Configuration/ShowRoleWiseUsers?RoleId=" + data.RoleId(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ShowUsers() method in RoleManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {

                    
                        $('#loadingUsersImgDiv').hide();
                        $('#divUsers').show();
                        vm.UsersList([]);

                    if (!(jsonResult[0].startsWith("INC"))) {
                        var MappedUsersList = $.map(jsonResult, function (result) {
                            return new UserModel(result);
                        })

                        vm.UsersList(MappedUsersList);

                    }

                    if (jsonResult.length > 0 && jsonResult[0] != null && jsonResult[0].startsWith("INC")) 
                    {
                        logger.logError(jsonResult[0] + " - " + 'Some Error Occured while fetching User Group details. Please contact the Administrator', 'Error', system.getModuleId(vm), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in ShowUsers() method in RoleManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in ShowUsers() method in RoleManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in ShowUsers() method in RoleManagement.js';
                    logger.logMessage(msg);
                }
            };
        }

        function GetSurveyRoleType() {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetSurveyRoleType",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetSurveyRoleType() method in RoleManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    $('#loadingUsersImgDiv').hide();
                    $('#divUsers').show();
                    vm.SurveyRoleType([]);

                    console.log(jsonResult[0]);
                    console.log(jsonResult[0].Incident_Description);

                    if (jsonResult.length > 0)
                    {
                        if (jsonResult[0].Incident_Description == null) {
                            var MappedSurveyRoleList = $.map(jsonResult, function (result) {
                                return new SurveyRoleModel(result);
                            })
                            vm.SurveyRoleType(MappedSurveyRoleList); 
                        }
                    }

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null && jsonResult[0].Incident_Description.startsWith("INC")) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'Some Error Occured while fetching User Group details. Please contact the Administrator', 'Error', system.getModuleId(vm), true);
                    }

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSurveyRoleType() method in RoleManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyRoleType() method in RoleManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyRoleType() method in RoleManagement.js';
                    logger.logMessage(msg);
                }
            };
        }
        //---------------------------------------------------------------------Logic Related to Show Users Attached to a specific Role ends here-------------------------------------------

        //---------------------------------------------------------------------Logic to Show Edit Role Pop-Up Starts Here---------------------------------------------------------------------
        function ShowEditRolePopUp(data, event) {
            try {
                vm.PopUpActionType("Edit");
                vm.PopUpActionTitle("Edit Role Details - " + data.RoleName());
                vm.PopUpActionCss("fa fa-edit");
                vm.RolePopUpData("");
                vm.SelectedSurveyRoleMultiType([]);
                GetSurveyRoleType().then(function(){
                PreparePageAccess(data);
                    ModuleTblObj = $('#tblModule').DataTable({
                    "ordering": false,
                    "responsive": true,
                    "info": false,
                    "paging": false,
                    "searching": false,
                    "columnDefs": [
                        
                        { "targets": [0], "orderable": false, "className": "details-control action-bgcolor" }]
                    });

                

                    var splitID = $.map(data.SurveyRole().split(","), $.trim);
                    var TempRoleList = new Array();
                    vm.SurveyEditRoleType("");                    
                    for (var i = 0; i < vm.SurveyRoleType().length; i++) {
                        var counter = 0;
                        for (var j = 0; j < splitID.length; j++) {
                            if (vm.SurveyRoleType()[i].SurveyRole() == splitID[j]) {
                                counter++;
                            }
                        }
                        if (counter == 0 && vm.SurveyRoleType()[i].SurveyRoleType() !== "NA") {
                            TempRoleList.push(new Object({
                            Checked: vm.SurveyRoleType()[i].Checked(),
                            SurveyRole: vm.SurveyRoleType()[i].SurveyRole(),
                            SurveyRoleDescription: vm.SurveyRoleType()[i].SurveyRoleDescription(),
                            SurveyRoleType: vm.SurveyRoleType()[i].SurveyRoleType()
                            }));
                        }
                    }
                    vm.SurveyEditRoleType(TempRoleList);
                $('#frmRoleAction').modal('show');
                setTimeout("$('#rolename').focus();", 200);

                    if (vm.SurveyEditRoleType().length === 0) 
                        $("#SurveyRoleTypeMultiSelectEdit").hide();
                    else
                        $("#SurveyRoleTypeMultiSelectEdit").multiselect();
                })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowEditRolePopUp() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function UpdateRoleDetails(JsonData) {
            try {
                csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/UpdateRole",
                    headers: headers,
                    type: "POST",
                    applicationType: "application/json",
                    dataType: "json",
                    data: JsonData
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in UpdateRoleDetails() method in RoleManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult != null && jsonResult.length >= 1) {
                        var code = jsonResult.slice(0, 1);
                        var msg = jsonResult.slice(2, 11);
                        if (jsonResult == '1') {
                            GetAllRoles();
                            logger.logSuccess('Role details updated successfully.', 'Success', system.getModuleId(vm), true);
                        }
                        else if (code == '2')
                            logger.logError(msg + ' - This Role does not exist. Please refresh the page and try again.', 'Error', system.getModuleId(vm), true);
                        else
                            logger.logError(jsonResult + ' - An error occurred while updating Role details. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                    }
                    }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UpdateRoleDetails() method in RoleManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UpdateRoleDetails() method in RoleManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpdateRoleDetails() method in RoleManagement.js';
                    logger.logMessage(msg);
                }
            };
        }

        //---------------------------------------------------------------------Logic to Show Edit Role Pop-Up Ends Here---------------------------------------------------------------------

        //---------------------------------------------------------------------Logic to Show View Role Pop-Up Starts Here---------------------------------------------------------------------
        function ShowViewRolePopUp(data, event) {
            try {
                vm.PopUpActionType("View");
                vm.PopUpActionTitle("Role Details - " + data.RoleName());
                vm.PopUpActionCss("fa fa-eye text-success");
                vm.RolePopUpData("");
                PreparePageAccess(data);
                ModuleTblObj = $('#tblModule').DataTable({
                    "ordering": false,
                    "responsive": true,
                    "info": false,
                    "paging": false,
                    "searching": false,
                    "columnDefs": [
                        
                        { "targets": [0], "orderable": false, "className": "details-control action-bgcolor" }]
                });
                $('#frmRoleAction').modal('show');
                $('#modalContent').css({
                    'margin-top': '25%'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowViewRolePopUp() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }
        //---------------------------------------------------------------------Logic to Show View Role Pop-Up Ends Here---------------------------------------------------------------------

        //---------------------------------------------------------------------Logic to Show Add Role Pop-Up Starts Here---------------------------------------------------------------------
        function ShowAddRolePopUp(data, event) {
            try {
                vm.PopUpActionType("Add");
                vm.PopUpActionTitle("Add Role Details");
                vm.PopUpActionCss("fa fa-plus");
                vm.RolePopUpData("");
                GetSurveyRoleType().then(function () {
                PreparePageAccessForAdd();
                    ModuleTblObj = $('#tblModule').DataTable({
                        "ordering": false,
                        "responsive": true,
                        "info": false,
                        "paging": false,
                        "searching": false,
                        "columnDefs": [
                            
                            { "targets": [0], "orderable": false, "className": "details-control action-bgcolor" }]
                    });
				$('#frmRoleAction').modal('show');
				$('#modalContent').css({
					'margin-top': '5%'
                });
				setTimeout("$('#rolename').focus();", 200);
                vm.SelectedSurveyRoleMultiType([]);
				$("#SurveyRoleTypeMultiSelect").multiselect();
                })

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowAddRolePopUp() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function AddRoleDetails(JsonData) {
            try {
     
                csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/AddRole",
                    headers: headers,
                    type: "POST",
                    applicationType: "application/json",
                    dataType: "json",
                    data: JsonData
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in AddRoleDetails() method in RoleManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult.Flag == -99)
                    {
                        logger.logError(jsonResult.FlagDescription + ' - An error occurred while adding Role details. Please contact your System Administrator.', 'Error', system.getModuleId(vm), true);
                    }
                    else
                    {
                        GetAllRoles();
                        logger.logSuccess('Role details added successfully.', 'Success', system.getModuleId(vm), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in AddRoleDetails() method in RoleManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in AddRoleDetails() method in RoleManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in AddRoleDetails() method in RoleManagement.js';
                    logger.logMessage(msg);
                }
            };
        }
        //---------------------------------------------------------------------Logic to Show Add Role Pop-Up Starts Here---------------------------------------------------------------------

        //---------------------------------------------------------------------Logic to Show Delete Role Pop-Up Starts Here---------------------------------------------------------------------
        function ShowDeleteRolePopUp(data, event) {
            try {
                app.showMessage('Are you sure you want to Delete this Role?', 'Delete Role - ' + data.RoleName(), ['Confirm', 'Cancel'], false, { primaryButtonClass: "mr-2 btn-curved fa fa-check btn btn-success autofocus", secondaryButtonClass: "mr-2 btn-curved fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-plus text-default' })
                    .then(function (option) {
                        if (option === 'Confirm') {
                            DeleteRole(data, event);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowDeletePopUp() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function DeleteRole(data, event) {
            try {
                csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/DeleteRole?RoleId=" + data.RoleId(),
                    type: "POST",
                    headers: headers
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteRole() method in RoleManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult != null && jsonResult.length >= 1) {
                        var code = jsonResult.slice(0, 1);
                        var msg = jsonResult.slice(2, 12);
                        if (jsonResult == '1') {
                            GetAllRoles();
                            logger.logSuccess('Role details deleted successfully.', 'Success', system.getModuleId(vm), true);
                        }
                        else if (code == '2')
                            logger.logError(msg + ' - The Role that you are trying to delete does not exist. Please refresh the page and try again.', 'Error', system.getModuleId(vm), true);
                        else if (code == '3')
                            logger.logError(msg + ' - This Role can not be deleted as there are users assigned to it.', 'Error', system.getModuleId(vm), true);
                        else
                            logger.logError(jsonResult + ' - An error occurred while deleting Role details. Please contact your Administrator', 'Error', system.getModuleId(vm), true);
                    }
                     }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteRole() method in RoleManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteRole() method in RoleManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteRole() method in RoleManagement.js';
                    logger.logMessage(msg);
                }
            };
        }
        //---------------------------------------------------------------------Logic to Show Delete Role Pop-Up Ends Here---------------------------------------------------------------------



        //---------------------------------------------------------------------Logic For Common Methods Related to View/Edit/Add Role Pop-Up Starts Here--------------------------------
        function PreparePageAccess(data) {
            try {
                var TempModuleList = new Array();
                var RoleIndex = 0;
                for (var i = 0; i < vm.RolesList().length; i++) {
                    if (vm.RolesList()[i].RoleId() == data.RoleId()) {
                        RoleIndex = i;
                        break;
                    }
                }
                for (var i = 0; i < vm.PageList().length; i++) {
                    var ModuleCounter = 0;
                    var ModuleIndex = 0;
                    for (var j = 0; j < vm.RolesList()[RoleIndex].ModuleList().length; j++) {
                        if (vm.RolesList()[RoleIndex].ModuleList()[j].ModuleId() == vm.PageList()[i].ModuleId()) {
                            ModuleCounter++;
                            ModuleIndex = j;
                            break;
                        }
                    }
                    var TempPageList = new Array();
                    if (ModuleCounter > 0) {
                        for (var x = 0; x < vm.PageList()[i].PageList().length; x++) {
                            var PageCounter = 0;
                            for (var y = 0; y < vm.RolesList()[RoleIndex].ModuleList()[ModuleIndex].PageList().length; y++) {
                                if (vm.RolesList()[RoleIndex].ModuleList()[ModuleIndex].PageList()[y].PageId() == vm.PageList()[i].PageList()[x].PageId()) {
                                    PageCounter++;
                                    TempPageList.push(new Object({
                                        PageId: vm.RolesList()[RoleIndex].ModuleList()[ModuleIndex].PageList()[y].PageId(),
                                        PageCodeName: vm.PageList()[i].PageList()[x].PageName(),
                                        ActiveIndicator: true,
                                        ReadAccess: vm.RolesList()[RoleIndex].ModuleList()[ModuleIndex].PageList()[y].ReadAccess(),
                                        WriteAccess: vm.RolesList()[RoleIndex].ModuleList()[ModuleIndex].PageList()[y].WriteAccess()
                                    }));
                                    break;
                                }
                            }
                            if (PageCounter == 0) {
                                TempPageList.push(new Object({
                                    PageId: vm.PageList()[i].PageList()[x].PageId(),
                                    PageCodeName: vm.PageList()[i].PageList()[x].PageName(),
                                    ActiveIndicator: false,
                                    ReadAccess: false,
                                    WriteAccess: false
                                }));
                            }
                        }
                    }
                    else {
                        for (var x = 0; x < vm.PageList()[i].PageList().length; x++) {
                            TempPageList.push(new Object({
                                PageId: vm.PageList()[i].PageList()[x].PageId(),
                                PageCodeName: vm.PageList()[i].PageList()[x].PageName(),
                                ActiveIndicator: false,
                                ReadAccess: false,
                                WriteAccess: false
                            }));
                        }
                    }

                    TempModuleList.push(new Object({
                        ModuleId: vm.PageList()[i].ModuleId(),
                        ModuleCodeName: vm.PageList()[i].ModuleName(),
                        ActiveIndicator: false,
                        PageList: TempPageList
                    }));

                }

                var SurveySuperUser;

                if (data.SurveySuperUser() == "YES")
                {
                    SurveySuperUser = "(Survey Super User)";
                }
                else
                {
                    SurveySuperUser = ""
                }

                var MappedPopUpData = new RoleModel({
                    PrimaryRoleId: data.RoleId(),
                    PrimaryRoleName: data.RoleName(),
                    ModuleList: TempModuleList,
                    SurveyRoleType: data.SurveyRoleType(),
                    SurveyRole: data.SurveyRole(),
                    SurveySuperUser: SurveySuperUser
                });

                vm.RolePopUpData(MappedPopUpData);
                vm.SelectedSurveyRoleType(data.SurveyRoleType());

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PreparePageAccess() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function PreparePageAccessForAdd() {
            try {
                vm.isSurveyUserApplicable(false);
                var TempModuleList = new Array();
                for (var i = 0; i < vm.PageList().length; i++) {
                    var TempPageList = new Array();
                    for (var j = 0; j < vm.PageList()[i].PageList().length; j++) {
                        TempPageList.push(new Object({
                            PageId: vm.PageList()[i].PageList()[j].PageId(),
                            PageCodeName: vm.PageList()[i].PageList()[j].PageName(),
                            ActiveIndicator: false,
                            ReadAccess: false,
                            WriteAccess: false
                        }));
                    }
                    TempModuleList.push(new Object({
                        ModuleId: vm.PageList()[i].ModuleId(),
                        ModuleCodeName: vm.PageList()[i].ModuleName(),
                        ActiveIndicator: false,
                        PageList: TempPageList
                    }));
                }

                var MappedPopUpData = new RoleModel({
                    PrimaryRoleId: 0, PrimaryRoleName: "",
                    ModuleList: TempModuleList,
                    SurveyRoleType: "NA",
                    SurveyRole: "",
                    SurveySuperUser: ""
                });
                vm.RolePopUpData(MappedPopUpData);
                vm.SelectedSurveyRoleType(vm.RolePopUpData().SurveyRoleType());
                document.getElementById(vm.RolePopUpData().SurveyRoleType()).checked = true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PreparePageAccessForAdd() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function PopUpRowClick(data, event) {
            try {
                var tr = $(event.currentTarget).closest('tr');
                var row = ModuleTblObj.row(tr);
                checkExpandedRow(row, false);
                if (row.child.isShown()) {
                    //close the open row
                    row.child.hide();
                    tr.removeClass('shown');
                }
                else {
                    // Open this row
                    row.child(CreatePageTable(data)).show();
                    tr.addClass('shown');
                    ko.applyBindingsToNode($('#tblPageDetails').find('tbody').get(0), { foreach: data.PageList() }, data.PageList());
                    for (var i = 0; i < $('#tblPageDetails tbody tr').length; i++) {
                        for (var j = 0; j < data.PageList().length; j++) {
                            if (data.PageList()[j].PageId() == $($('#tblPageDetails tbody tr').get(i)).find('td').get(0).id) {
                                ko.applyBindingsToNode($($($('#tblPageDetails tbody tr').get(i)).find('td').get(0)).find('input').get(0), { css: { 'disabled': (vm.PopUpActionType() == "View") }, event: { click: vm.PageSelectClick } }, data.PageList()[j]);
                                ko.applyBindingsToNode($($($('#tblPageDetails tbody tr').get(i)).find('td').get(2)).find('input').get(0), { css: { 'disabled': (vm.PopUpActionType() == "View") }, event: { click: vm.PageReadClick } }, data.PageList()[j]);
                                ko.applyBindingsToNode($($($('#tblPageDetails tbody tr').get(i)).find('td').get(3)).find('input').get(0), { css: { 'disabled': (vm.PopUpActionType() == "View") }, event: { click: vm.PageWriteClick } }, data.PageList()[j]);
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PopUpRowClick() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function checkExpandedRow(row, isPaginating) {
            try {
                var currentRowIndex;
                var rowsInTable = $('#tblModule').find('tr');
                if (isPaginating)
                    currentRowIndex = -1;
                else
                    currentRowIndex = row.index();
                var info = ModuleTblObj.page.info();
                for (var i = 1, j = (rowsInTable.length) ; i < j; i++) {
                    var tr = $('#tblModule').find('tr').get(i);
                    if (ModuleTblObj.row(tr).index() != row.index()) {
                        var tableRowIndex = (info.page * info.length) + (i - 1);
                        if ((ModuleTblObj.row(tableRowIndex).child() != undefined) && (ModuleTblObj.row(tableRowIndex).child.isShown())) {
                            ModuleTblObj.row(tableRowIndex).child.remove();
                            tr.removeAttribute('class', 'shown');
                            j = $('#tblModule').find('tr').length;
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: checkExpandedRow() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function CreatePageTable(data) {
            try {
                var RowChildHTML =
                    '<div class="child-active" style="margin-left:3em;"><div class="">' +
                        '<table id="tblPageDetails" class="table table-bordered" cellspacing="0">' +
                        '<thead>' +
                            '<tr>' +
                                '<th class="site_name">Select</th>' +
                                '<th class="site_name">Page Name</th>' +
                                '<th class="site_name">Read-Only Access</th>' +
                                '<th class="site_name">Read-Write Access</th>' +
                            '</tr>' +
                        '</thead>' +
                        '<tbody data-bind="foreach:data.PageList">' +
                            '<tr>' +
                                '<td class="text-center" data-bind="attr:{id: PageId}"><label class="cc-checkbox"><input type="checkbox" data-bind="checked: ActiveIndicator, css:{"disabled": ($root.PopUpActionType() == "View")}, event: {click: $root.PageSelectClick}"/> <span class="cc-facet-result-text tag-text"></span></label></td>' +
                                '<td data-bind="text: PageName"></td>' +
                                '<td class="text-center"><label class="cc-checkbox"><input type="checkbox" data-bind="checked: ReadAccess, css:{"disabled": ($root.PopUpActionType() == "View")}, event: {click: $root.PageReadClick}"/><span class="cc-facet-result-text tag-text"></span></label></td>' +
                                '<td class="text-center"><label class="cc-checkbox"><input type="checkbox" data-bind="checked: WriteAccess, css:{"disabled": ($root.PopUpActionType() == "View")},  event: {click: $root.PageWriteClick}"/><span class="cc-facet-result-text tag-text"></span></label></td>' +
                            '</tr>' +
                        '</tbody>' +
                    '</table><br/></div>';
                return RowChildHTML;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CreatePageTable() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function PageReadClick(data, event) {
            try {
                data.ActiveIndicator(true);
                data.ReadAccess(true);
                data.WriteAccess(false);
                return true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PageReadClick() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function PageWriteClick(data, event) {
            try {
                data.ActiveIndicator(true);
                data.ReadAccess(false);
                data.WriteAccess(true);
                return true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PageWriteClick() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function PageSelectClick(data, event) {
            try {
                if (event.currentTarget.checked) {
                    data.ActiveIndicator(true);
                    data.ReadAccess(true);
                    data.WriteAccess(false);
                }
                else {
                    data.ActiveIndicator(false);
                    data.ReadAccess(false);
                    data.WriteAccess(false);
                }
                return true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PageSelectClick() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }
        //---------------------------------------------------------------------Logic For Common Methods Related to View/Edit/Add Role Pop-Up Ends Here--------------------------------

        //---------------------------------------------------------------------Logic To Save Role Details Starts Here------------------------------------------------------------------
        function SurveyRoleTypeChanged(data, event) {
            try {
                vm.SelectedSurveyRoleType(event.currentTarget.value);
                if (event.currentTarget.value == "RESP" || event.currentTarget.value == "REV" || event.currentTarget.value == "AI_ASG" || event.currentTarget.value == "AI_REV")
                {
                    vm.isSurveyUserApplicable(true);                    
                }
                else
                {
                    vm.isSurveyUserApplicable(false);
                }

                if (vm.isSurveyUserApplicable())
                {
                    document.getElementById("No").checked = true;
                }
                
                return true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyRoleTypeChanged() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function SurveySuperUserCheck(data, event) {
            try {
                vm.SelectedSurveySuperUserCheck(event.currentTarget.id);
                return true;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveySuperUserCheck() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }


        function SaveRoleDetails(data, event) {
            try {
                if (ValidateRoleDetails(data)) {
                    var JsonData = CleanseDataForSaving(data, vm.PopUpActionType());
                    if (vm.PopUpActionType() == "Edit")
                        UpdateRoleDetails(JsonData);
                    else if (vm.PopUpActionType() == "Add")
                        AddRoleDetails(JsonData);
                    $('#frmRoleAction').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveRoleDetails() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function ValidateRoleDetails(data) {
            try {
                var EmptyNameCheck = 0;
                var DuplicateNameCheck = 0;
                var NoAccessCheck = 0;
                var Result = false;

                if (data.RoleName() == "")
                    EmptyNameCheck = 1;

                var RowIndex = -1;
                for (var i = 0; i < vm.RolesList().length; i++) {
                    if (vm.RolesList()[i].RoleId() == data.RoleId())
                        RowIndex = i;
                }

                for (var i = 0; i < vm.RolesList().length; i++) {
                    if ((vm.RolesList()[i].RoleName().toUpperCase() == data.RoleName().toUpperCase()) && (i != RowIndex))
                        DuplicateNameCheck++;
                }

                for (var i = 0; i < data.ModuleList().length; i++) {
                    for (var j = 0; j < data.ModuleList()[i].PageList().length; j++) {
                        if (data.ModuleList()[i].PageList()[j].ActiveIndicator() == true)
                            NoAccessCheck++;
                    }
                }

                if (EmptyNameCheck == 1) {
                    $('#valError').text("Role Name is required.");
                    $('#valError').show();
                }
                else if (DuplicateNameCheck > 0) {
                    $('#valError').text("Duplicate Role Name found. Please enter a different Role Name.");
                    $('#valError').show();
                }
                //else if (vm.PopUpActionType() != "Edit" && vm.SelectedSurveyRoleMultiType().length === 0) {
                //    $('#valError').text("Select atleast one Role Type.");
                //    $('#valError').show();
                //}
                else if (NoAccessCheck == 0) {
                    $('#valError').text("No access has been assigned to this Role. Please provide access to one or more screens to this role before saving the Role details.");
                    $('#valError').show();
                }
                else {
                    $('#valError').text("");
                    $('#valError').hide();
                    Result = true;
                }
                return Result;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateRoleDetails() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        function CleanseDataForSaving(data, flagEvent) {
            try {
                var TempModuleList = new Array();
                for (var i = 0; i < data.ModuleList().length; i++) {
                    var TempPageList = new Array();
                    for (var j = 0; j < data.ModuleList()[i].PageList().length; j++) {
                        if (data.ModuleList()[i].PageList()[j].ActiveIndicator() == true)
                            TempPageList.push(new Object({
                                PageId: data.ModuleList()[i].PageList()[j].PageId(),
                                PageCodeName: data.ModuleList()[i].PageList()[j].PageName(),
                                ActiveIndicator: data.ModuleList()[i].PageList()[j].ActiveIndicator(),
                                ReadAccess: data.ModuleList()[i].PageList()[j].ReadAccess(),
                                WriteAccess: data.ModuleList()[i].PageList()[j].WriteAccess()
                            }));
                    }

                    if (TempPageList.length > 0) {
                        TempModuleList.push(new Object({
                            ModuleId: data.ModuleList()[i].ModuleId(),
                            ModuleCodeName: data.ModuleList()[i].ModuleName(),
                            ActiveIndicator: data.ModuleList()[i].ActiveIndicator(),
                            PageList: TempPageList
                        }));
                    }
                }
                var SurveyRole = "";

                    for (var i = 0; i < vm.SelectedSurveyRoleMultiType().length; i++) {
                        if (i == 0) {
                            SurveyRole = vm.SelectedSurveyRoleMultiType()[i];
                        } else {
                            SurveyRole += "," + vm.SelectedSurveyRoleMultiType()[i];
                        }
                    }
                var TempRoleDetail = new Object({
                    PrimaryRoleId: data.RoleId(),
                    PrimaryRoleName: data.RoleName(),
                    ModuleList: TempModuleList,
                    SurveyRoleType: vm.SelectedSurveyRoleType(),
                    SurveyRole: SurveyRole,
                    SurveySuperUser: vm.SelectedSurveySuperUserCheck()
                });

                var mappedRoleData = new RoleModel(TempRoleDetail);
                vm.DataToBeSaved(mappedRoleData);
                return TempRoleDetail;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CleanseDataForSaving() method in RoleManagement.js';
                logger.logMessage(msg);
            }
        }

        //---------------------------------------------------------------------Logic To Save Role Details Starts Here------------------------------------------------------------------

        //---------------------------------------------------------------------Model Definition Starts Here----------------------------------------------------------------------------------

        function RoleModel(item) {
            var self = this;
            self.RoleId = ko.observable(item.PrimaryRoleId);
            self.RoleName = ko.observable($('<div/>').html(item.PrimaryRoleName).text());
            self.SurveyRoleType = ko.observable(item.SurveyRoleType);
            self.SurveyRole = ko.observable($('<div/>').html(item.SurveyRole).text());
            self.SurveySuperUser = ko.observable($('<div/>').html(item.SurveySuperUser).text())
            var MappedModuleList = $.map(item.ModuleList, function (result) {
                return new ModuleModel(result);
            })
            self.ModuleList = ko.observableArray(MappedModuleList);  
        }

        function ModuleModel(item) {
            var self = this;
            self.ModuleId = ko.observable(item.ModuleId);
            self.ModuleName = ko.observable(item.ModuleCodeName);
            self.ActiveIndicator = ko.observable(item.ActiveIndicator);
            var MappedPageList = $.map(item.PageList, function (result) {
                return new PageModel(result);
            })
            self.PageList = ko.observableArray(MappedPageList);
        }

        function PageModel(item) {
            var self = this;
            self.PageId = ko.observable(item.PageId);
            self.PageName = ko.observable(item.PageCodeName);
            self.ActiveIndicator = ko.observable(item.ActiveIndicator);
            self.ReadAccess = ko.observable(item.ReadAccess);
            self.WriteAccess = ko.observable(item.WriteAccess);
        }

        function UserModel(item) {
            var self = this;
            self.UserName = ko.observable(item);
        }

        function SurveyRoleModel(item) {
            var self = this;
            self.SurveyRole = ko.observable(item.SurveyRole);
            self.SurveyRoleType = ko.observable(item.SurveyRoleType);
            self.SurveyRoleDescription = ko.observable($('<div/>').html(item.SurveyRoleDescription).text());
            self.Checked = ko.observable(item.Checked)
        }

        //---------------------------------------------------------------------Model Definition Starts Here----------------------------------------------------------------------------------
    });
